import theHam from '../../../assets/img/Work/the-ham.jpg';
import pizza from '../../../assets/img/Work/pizza.jpg';
import forkio from '../../../assets/img/Work/forkio.jpg';
import airTicketBooking from '../../../assets/img/Work/air-ticket-booking.jpg';
import tinder from '../../../assets/img/Work/tinder.jpg';
import todo from '../../../assets/img/Work/todo.jpg';
import replicaGoogleKeep from '../../../assets/img/Work/replica-google-keep.jpg';
import ndb from '../../../assets/img/Work/ndb.jpg';
import btre from '../../../assets/img/Work/btre.jpg';

export const photos = [
  {
    src: `${btre}`,
    url: 'http://52.28.62.150',
    description: 'BTRE (Python Django)'
  },
  {
    src: `${replicaGoogleKeep}`,
    url: 'https://github.com/fykss/node-todo',
    description: 'Replica Google keep (NodeJS)'
  },
  {
    src: `${ndb}`,
    url: 'https://github.com/fykss/ndb',
    description: 'NDB - startup (Java Spring)'
  },
  {
    src: `${todo}`,
    url: 'https://fykss.github.io/react-app/',
    description: 'Application todo list (React)'
  },
  {
    src: `${tinder}`,
    url: 'https://github.com/fykss/java-tinder',
    description: 'Tinder - replica (Java EE)'
  },
  {
    src: `${airTicketBooking}`,
    url: 'https://gitlab.com/NazDen/javacorestepproject',
    description: 'Console application "Air ticket booking" (Java)'
  },
  {
    src: `${pizza}`,
    url: 'https://fykss.github.io/web-pizza/',
    description: 'Responsive coding (HTML, CSS, JS)'
  },
  {
    src: `${forkio}`,
    url: 'https://fykss.github.io/forkio/',
    description: 'Forkio - teamwork (HTML, CSS, JS)'
  },
  {
    src: `${theHam}`,
    url: 'https://fykss.github.io/the-ham/',
    description: 'First web project (HTML, CSS, JS)'
  }
];
